module.exports = __webpack_public_path__ + "img/20251009.87cbb75e.jpg";